import { TableRow, TableCell, Skeleton } from '@mui/material'
import type { FC } from 'react'

import { rowHeight, rowsPerPage } from './utils'

const Loading: FC = () => (
  <>
    {new Array(rowsPerPage).fill(undefined).map((_, i) => (
      <TableRow key={i} sx={{ height: rowHeight }}>
        <TableCell component="th" scope="row">
          <span data-testid="completed-table-loading">
            <Skeleton variant="text" width={100} />
          </span>
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} />
        </TableCell>
      </TableRow>
    ))}
  </>
)

export default Loading
